import { defineStore } from "pinia"
import { Api } from "~/api/Api.ts"
import {
    useDevisStore,
    useProjetStore,
    useClientStore,
    useAuthStore,
    useRdvStore,
    useDataCacheStore,
} from "~/stores"

export const useSpaceStore = defineStore("space", {
    state: () => ({
        hasFintectureAccount: false,
        fintectureCheckLoading: false,
    }),
    getters: {
        projetStore() {
            return useProjetStore()
        },
        devisStore() {
            return useDevisStore()
        },
        clientStore() {
            return useClientStore()
        },
        authStore() {
            return useAuthStore()
        },
        rdvStore() {
            return useRdvStore()
        },
        dataCache() {
            return useDataCacheStore()
        },
        dataCacheStore() {
            return useDataCacheStore()
        },
        getColor() {
            return this.dataCacheStore.data?.COMPANY?.COLOR || "#BD1734"
        },
        getAgence() {
            return this.authStore.getUser?.AGENCE
        },
        getProject() {
            return this.projetStore.items
                .filter(
                    (item) =>
                        item.IDCLIENT === this.authStore.getUser?.IDCLIENT,
                )
                .sort(
                    (a, b) =>
                        new Date(b.DATE_CREATION) - new Date(a.DATE_CREATION),
                )
        },
        getAllDevis() {
            return this.devisStore.items.filter(
                (item) => item.IDCLIENT === this.authStore.getUser?.IDCLIENT,
            )
        },
        getCommandes() {
            return this.getAllDevis.filter((item) => item.isCommande)
        },
        getPublicDevis() {
            return this.getAllDevis.filter((item) => item.isPublicDevis)
        },
    },
    actions: {
        async getClientDetail() {
            const response = await Api.space.spaceGetClientDetails()
            await this.clientStore.ready
            this.clientStore.setItems(response)
        },
        async fetchHomePage() {
            const items = await Api.space.spaceGetProjectsList()
            await this.projetStore.ready
            this.projetStore.setItems(items)
        },
        async fetchProjectPage(id_projet) {
            const items = await Api.space.spaceGetDevisList(id_projet)
            await this.devisStore.ready
            this.devisStore.setItems(items)
        },
        async fetchDevisPage(id_devis) {
            const items = await Api.space.spaceGetDevisDetails(id_devis)
            await this.devisStore.ready
            this.devisStore.setItems(items)
        },
        async fetchNextRdv() {
            const response = await Api.space.spaceNextRdvs()
            await this.rdvStore.ready
            this.rdvStore.setItems(response)
            return response
        },
        async fetchNextDevisEnAttente() {
            const response = await Api.space.spaceNextDevisEnAttente()
            await this.devisStore.ready
            this.devisStore.setItems(response, false)
            return response
        },
        async signDevis(id_devis) {
            const response = await Api.space.spaceSignDevis(id_devis)
            return response
        },
        async checkFintectureAccount() {
            this.fintectureCheckLoading = true
            try {
                const response: any =
                    await Api.invoicePayments.invoicePaymentsCustomerHasFintecture()
                this.hasFintectureAccount = response.has_account === true
                return this.hasFintectureAccount
            } catch (error) {
                this.hasFintectureAccount = false
                return false
            } finally {
                this.fintectureCheckLoading = false
            }
        },
        async createFintecturePaymentLink(payload) {
            // Appel direct à l'API car le client auto-généré n'a pas les bons paramètres
            const response = await Api.request.request({
                method: "POST",
                url: "/fintecture/generate_link",
                body: payload,
                mediaType: "application/json",
            })
            return response.url
        },
    },
})
